// extracted by mini-css-extract-plugin
module.exports = {"margin":"index-module--margin--yFNBe","padding":"index-module--padding--34rXr","background":"index-module--background--9de6i"};